import { getFullUrl } from '../../utils';
import { AudioManager } from './AudioManager';

export class BgmAudioController extends AudioManager {
  public static baseGainNode: GainNode;

  private static instanceList: BgmAudioController[] = [];

  private constructor(
    src: string,
    audioConfig: Partial<HTMLAudioElement> = {},
    gainOptions: Partial<GainOptions> = {}
  ) {
    super(
      src,
      BgmAudioController.baseGainNode,
      { ...audioConfig },
      gainOptions
    );
    BgmAudioController.instanceList.push(this);
  }

  public static closeAll() {
    BgmAudioController.instanceList.forEach((instance) => instance.close());
    BgmAudioController.instanceList = [];
  }

  /**
   * Each src only create one instance, so if there are same src without different config,
   * you should use updateAudioConfig to update the config.
   */
  public static getInstance(
    src: string,
    audioConfig: Partial<HTMLAudioElement> = { loop: true },
    gainOptions: Partial<GainOptions> = {}
  ) {
    const instance = BgmAudioController.instanceList.find(
      (i) => i.audioUrl === getFullUrl(src)
    );

    if (instance) {
      return instance;
    }

    return new BgmAudioController(src, audioConfig, gainOptions);
  }

  public static override init(isMute = false) {
    super.init();
    if (!BgmAudioController.baseGainNode) {
      BgmAudioController.baseGainNode = AudioManager.AUDIO_CONTEXT.createGain();
      BgmAudioController.setIsMute(isMute);
    }
  }

  public static setIsMute(value: boolean) {
    BgmAudioController.setVolumeSmoothly(
      BgmAudioController.baseGainNode,
      value ? 0 : 1
    );
  }
}
